module.exports = __webpack_public_path__ + "static/PaginaStartEndorfina-dde878475ee736203b4403f47ec4aee7.png";